import { render, staticRenderFns } from "./UpgradeToMenuDialog.vue?vue&type=template&id=534612d6&scoped=true"
import script from "./UpgradeToMenuDialog.vue?vue&type=script&lang=js"
export * from "./UpgradeToMenuDialog.vue?vue&type=script&lang=js"
import style0 from "./UpgradeToMenuDialog.vue?vue&type=style&index=0&id=534612d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534612d6",
  null
  
)

export default component.exports